import { Component, OnDestroy } from '@angular/core';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { first, Observable, Subject, switchMap, takeUntil } from 'rxjs';

import { ApiSubjectCategory, ApiTopic, SubjectCategoryType } from 'content-manager/src/app/core/open-api/content-manager-api-client';
import { IProjectUpdateTopicsDialogData } from 'content-manager/src/app/projects/project/topics/update-topics-dialog/project-update-topics-dialog-data';

@Component({
    templateUrl: './project-update-topics-dialog.component.html',
    standalone: false
})
export class ProjectUpdateTopicsDialogComponent implements OnDestroy {

    public readonly dialogData: IProjectUpdateTopicsDialogData;

    public selectedTopicHeadings: string[] = [];

    public requestInProcess: boolean;

    public topics$: Observable<ApiTopic[]>;

    private readonly _destroy$ = new Subject<void>();

    constructor(
        dialogConfig: DynamicDialogConfig,
        private readonly _dialogRef: DynamicDialogRef) {

        this.dialogData = dialogConfig.data;

        this.topics$ = this.dialogData.topics$;

        this.dialogData.existingTopicHeadings$
            .pipe(takeUntil(this._destroy$))
            .subscribe(topicHeadings => this.selectedTopicHeadings = topicHeadings);
    }

    public save(): void {
        this.requestInProcess = true;

        this.topics$.pipe(
            first(),
            switchMap(topics => {
                const subjectCategories = this._buildSubjectCategories(topics);
                return this.dialogData.updateAction(subjectCategories);
            }),
            takeUntil(this._destroy$)
        ).subscribe(() => {
            this.requestInProcess = false;
            this._dialogRef.close(true);
        });
    }

    private _buildSubjectCategories(topics: ApiTopic[]): ApiSubjectCategory[] {
        return this.selectedTopicHeadings
            .map(heading => topics.find(t => t.heading === heading))
            .filter((t): t is ApiTopic => !!t)
            .map(topic => new ApiSubjectCategory({
                subjectCategoryType: SubjectCategoryType.Topic,
                headingText: topic.heading
            }));
    }

    public ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }
}
